<template>
    <div class="string-cell" :class="field.alignment" @dblclick="enableEdit">
        <template v-if="editing">
            <input
                type="text"
                v-model="value"
                @blur="disableEdit"
                @keyup.enter="disableEdit"
                ref="input"
                class="borderless-input"
            />
        </template>
        <template v-else>
            <div class="text-wrapper">
                {{ value }}
            </div>
        </template>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "StringCell",
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            editing: false,
            value: this.record.data[this.field._id] || "",
        };
    },
    methods: {
        enableEdit() {
            console.log("enableEdit");
            this.editing = true;
            this.$nextTick(() => {
                this.$refs.input.focus();
            });
        },
        async disableEdit() {
            this.editing = false;
            try {
                const isChanged = this.record.data[this.field._id] !== this.value;
                if (isChanged) {
                    await this.$emit("update-record", {
                        recordId: this.record._id,
                        fieldId: this.field._id,
                        value: this.value,
                    });
                }
            } catch (error) {
                console.error(this.$t("tables.recordUpdatingError"), error);
                this.$message.error(this.$t("tables.recordUpdatingError"));
            }
        },
    },
});
</script>

<style scoped lang="scss">
.string-cell {
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    &.left {
        justify-content: flex-start;
    }

    &.center {
        justify-content: center;
    }

    &.right {
        justify-content: flex-end;
    }

    .borderless-input {
        border: none;
        outline: none;
        background: transparent;
        width: 100%;
        text-align: inherit;
    }

    .text-wrapper {
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
